import React from "react";
import Tabla from "./Tabla";
import permisos_icon from "../../../assets/vw/svg/permisos-rol.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import Loading from "../../../components/Loading";
import TablaArchivo from "./TablaInactivos";
import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";

class PermisosRol extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permisosRol: [],
      permisosRolFiltradas: [],
      roles: [],
      cargando: true,
      searchInput: "",
      option: "permisos",
      dataOriginal: [],
      permisosInactivo: [],
      permisosInactivoFiltrado: [],
      modal: {
        active: false,
        message: '',
        success: false
      },
      success: false
    };
  }

  componentDidMount() {
    Promise.all([
      fetch(process.env.REACT_APP_URL_DTO_BACK + "permisoxrol?rol=todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(process.env.REACT_APP_URL_DTO_BACK + "roles?rol=todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
    ])
      .then(([responseBodyPermisosRoles, responseBodyRoles]) => {
        const activas = responseBodyPermisosRoles.mensaje.filter((usuario) => {
          return usuario.activo === 1;
        });
        const rolesActivos = responseBodyRoles.mensaje.filter((item) => {
          return item.activo === 1;
        })
        this.setState({
          cargando: false,
          dataOriginal: responseBodyPermisosRoles.mensaje,
          permisosRol: activas,
          roles: rolesActivos,
          success: true
        });
      })
      .catch((errorP) => {
        this.setState({
          cargando: false, modal: {
            active: true,
            message: errorP.message,
            success: false
          },
          success: false
        });
        console.error(errorP.stack || errorP);
      });
  }

  handleChange = (event) => {
    if (this.state.option === "archivo") {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearchInactivas();
      });
    } else {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearch();
      });
    }
  };

  globalSearch = () => {
    let { permisosRol, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let permisosRolFiltradas = permisosRol.filter((value) => {
        return (value.rol.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.url.toLowerCase().includes(searchInput.toLowerCase()))
      });
      this.setState({ permisosRolFiltradas });
    } else {
      let permisosRolFiltradas = [];
      this.setState({ permisosRolFiltradas });
    }
  };

  globalSearchInactivas = () => {
    let { permisosInactivo, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let permisosInactivoFiltrado = permisosInactivo.filter((value) => {
        return (value.rol.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.url.toLowerCase().includes(searchInput.toLowerCase()))
      });
      this.setState({ permisosInactivoFiltrado });
    } else {
      let permisosInactivoFiltrado = [];
      this.setState({ permisosInactivoFiltrado });
    }
  };


  changeOption = (option) => {
    this.setState({ permisosInactivo: [], permisosInactivoFiltrado: [], permisosRolFiltradas: [] });
    this.setState({ option });
    if (option === "archivo") {
      this.permisosInactivos(this.state.dataOriginal);
    }
  };

  permisosInactivos = (data) => {
    const inactivas = data.filter((autenticacion) => {
      return autenticacion.activo === 0;
    });
    this.setState({ permisosInactivo: inactivas });
  };

  render() {
    return (
      <>
        <Menu />
        <Modal
          modalInfo={this.state.modal}
          setMostrarModal={(data) => {
            this.setState({ modal: data });
          }}
        />
        {
          this.state.cargando && <Loading />
        }
        <div className={`navegacion`}>
          {this.state.success ? (
            <>
              <div className=" posicionMenu">
                <ul className="d-flex flex-row px-0 my-0">
                  <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("permisos")}
                  >
                    <div
                      className={`nav-link nav-link-title active ps-0 ${this.state.option === "permisos"
                          ? " active border_menu"
                          : ""
                        }`}
                    >
                      <img
                        src={permisos_icon}
                        alt="permisos"
                        className="icono-menu me-3"
                      />
                      Permisos por rol
                    </div>
                  </li>
                  <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("archivo")}
                  >
                    <div
                      className={`nav-link active ps-0  ${this.state.option === "archivo"
                          ? " active border_menu"
                          : ""
                        }`}
                    >
                      <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                      Archivo
                    </div>
                  </li>
                </ul>
              </div>
              <div className="row border_vw pt-4 ms-0 mx-0">
                <div className="col-12 p-0 contenedor-table">
                  {this.state.option === "archivo" ? (
                    <TablaArchivo
                      permisosrol={
                        this.state.permisosInactivoFiltrado &&
                          this.state.permisosInactivoFiltrado.length
                          ? this.state.permisosInactivoFiltrado
                          : this.state.permisosInactivo
                      }
                      roles={this.state.roles}
                      servicio={this.props.servicio}
                      marca={this.props.marca}
                      marcaNombre={this.state.marca}
                      handleChange={this.handleChange}
                    ></TablaArchivo>
                  ) : (
                    <Tabla
                      permisosrol={
                        this.state.permisosRolFiltradas &&
                          this.state.permisosRolFiltradas.length
                          ? this.state.permisosRolFiltradas
                          : this.state.permisosRol
                      }
                      roles={this.state.roles}
                      servicio={this.props.servicio}
                      marca={this.props.marca}
                      marcaNombre={this.state.marca}
                      handleChange={this.handleChange}
                    ></Tabla>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {
                !this.state.cargando && <NoInfoScreen />
              }
            </>
          )
          }
        </div>
      </>
    );
  }
}

export default PermisosRol;
